import { ReactNode } from 'react';
import { Toaster } from '@e2n/ui';
import { Navigation } from '@/domain/navigation/features/navigation/Navigation';
import { AIChatGate } from '@/features/ai/AIChatGate.tsx';

export function DefaultPage({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="flex flex-col h-screen bg-neutrals-200">
        <div className="shrink-0">
          <Navigation />
        </div>
        <div className="flex flex-1 min-h-0">
          <div className="relative flex-1 min-w-0">
            <div className="h-full overflow-auto" id="body-container">
              {children}
            </div>
          </div>
          <AIChatGate />
        </div>
      </div>
      <Toaster />
    </>
  );
}
